import { __decorate } from "tslib";
import '../label/element';
import { css, html, LitElement, nothing } from 'lit';
import { property, query } from 'lit/decorators.js';
export class Radio extends LitElement {
    constructor() {
        super(...arguments);
        this.type = 'radio';
        this.testId = 'radio-input';
        this.disabled = false;
        this.checked = false;
        this.noLabel = false;
    }
    render() {
        return html `
            ${this.hasAttribute('noLabel')
            ? nothing
            : html `
                      <ep-label class="va" @click="${this.clickEvent}">
                          <slot>${this.label}</slot>
                      </ep-label>
                  `}
            <input @click="${this.clickSpan}" @change="${this.change}" type="${this.type}" data-testid="${this.testId}" value="${this.value}" />
            <span class="checkmark" @click="${this.clickSpan}"></span>
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', this.click);
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        // todo: _changedProperties.has('disabled') refactor and testing
        if (this.hasAttribute('disabled')) {
            this._input.setAttribute('disabled', '');
            this._labelItem.style.setProperty('--ep-label-cursor', 'not-allowed');
        }
        // todo: _changedProperties.has('name') refactor and testing
        if (this.name) {
            if (!this.hasAttribute('noLabel')) {
                this._labelItem.setAttribute('for', this.name);
            }
            this._input.setAttribute('name', this.name);
        }
        // todo: _changedProperties.has('checked') refactor and testing
        if (this.hasAttribute('checked') || this.checked) {
            this.setAttribute('checked', '');
            this._input.setAttribute('checked', '');
        }
        else {
            this.removeAttribute('checked');
            this._input.removeAttribute('checked');
        }
    }
    change(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        const currentTarget = e.currentTarget;
        this.checked = currentTarget.checked;
        this._input.dispatchEvent(new CustomEvent('changeAlt', {
            composed: true,
            bubbles: true,
            detail: {
                value: this.value,
                input: currentTarget,
                parent: this
            }
        }));
    }
    clickSpan(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        this.clickEvent(e);
    }
    clickEvent(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        if (this._input.hasAttribute('disabled')) {
            return;
        }
        // todo: refactor for SEEC-7719
        if (this._input.type == 'checkbox') {
            if (this._input.checked) {
                this.checked = false;
                this.removeAttribute('checked');
                this._input.removeAttribute('checked');
                this._input.checked = false;
                this.dispatchEvent(new CustomEvent('change', {
                    composed: true,
                    detail: this.value ? this.value : this._input.checked
                }));
                return;
            }
            if (!this._input.checked) {
                this.setAttribute('checked', '');
                this.checked = true;
                this._input.setAttribute('checked', '');
                this._input.checked = true;
            }
        }
        if (this._input.type == 'radio') {
            this.setAttribute('checked', '');
            this._input.setAttribute('checked', '');
            this._input.checked = true;
        }
        this.dispatchEvent(new CustomEvent('change', {
            composed: true,
            detail: this.value ? this.value : this._input.checked
        }));
    }
}
Radio.styles = css `
        :host(:focus-visible),
        input:focus-visible {
            outline: 0;
        }

        :host {
            display: inline-flex;
            cursor: pointer;
            flex-direction: var(--ep-radio-flex-direction);
            flex-wrap: var(--ep-radio-flex-wrap);
            align-items: var(--ep-radio-align-items);
            justify-content: var(--ep-radio-justify-content, space-between);
            align-content: var(--ep-radio-align-content);
        }

        .checkmark {
            position: relative;
            height: 14px;
            width: 14px;
            background-color: var(--ep-color-white);
            border: var(--ep-radio-border, 2px solid var(--ep-color-tertiary));
            border-radius: 50%;
            cursor: pointer;
        }

        ep-label.va {
            vertical-align: top;
        }

        input {
            display: none;
        }

        input:hover ~ .checkmark,
        .checkmark:hover,
        ep-label:hover ~ .checkmark {
            background-color: var(--ep-color-tertiary);
        }

        input[checked] ~ .checkmark {
            background-color: white;
            border-color: var(--ep-radio-checked-border-color, var(--ep-color-primary));
        }

        .checkmark:after {
            content: '';
            position: static;
            display: block;
            opacity: 0;
            margin: 3px 0 0 3px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: var(--ep-radio-checked-border-color, var(--ep-color-primary));
        }

        input[checked] ~ .checkmark:after {
            opacity: 1;
        }

        input:disabled ~ .checkmark:after {
            background-color: var(--ep-color-tertiary);
        }

        input:disabled ~ .checkmark {
            border-color: var(--ep-color-tertiary);
            background-color: lightgray;
        }

        input:disabled ~ .checkmark,
        input:disabled ~ .checkmark:after,
        input:disabled {
            cursor: not-allowed;
        }

        ep-label {
            padding: var(--ep-label-padding, 0 8px 0 10px);
            cursor: pointer;
        }
    `;
__decorate([
    property()
], Radio.prototype, "name", void 0);
__decorate([
    property()
], Radio.prototype, "label", void 0);
__decorate([
    property()
], Radio.prototype, "value", void 0);
__decorate([
    property({ type: Boolean })
], Radio.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], Radio.prototype, "checked", void 0);
__decorate([
    property({ type: Boolean })
], Radio.prototype, "required", void 0);
__decorate([
    property({ type: Boolean })
], Radio.prototype, "noLabel", void 0);
__decorate([
    query('input')
], Radio.prototype, "_input", void 0);
__decorate([
    query('ep-label')
], Radio.prototype, "_labelItem", void 0);
__decorate([
    query('slot')
], Radio.prototype, "_slot", void 0);
if (!customElements.get('ep-radio')) {
    customElements.define('ep-radio', Radio);
}
//# sourceMappingURL=element.js.map